/* Native editor display copy. Read-only; no network, storage, timers or listeners.
 * The current DOM is queried on each read so replaced theme-editor sections do not
 * retain stale settings. Absent/empty values never fall back to hard-coded prose.
 */
(function () {
  'use strict';
  const cache = new WeakMap();
  function htmlText(value) {
    return value.replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  window.AVAL_EDITOR_ISSUE = function (message) {
    const text = String(message == null ? '' : message);
    return Object.freeze({ invalid: true, message: text,
      toString: function () { return text; },
      toJSON: function () { return text; }
    });
  };
  window.AVAL_EDITOR_COPY = function (scope, key, html) {
    if (typeof scope !== 'string' || !/^[a-z][a-z0-9-]*$/.test(scope) ||
        typeof key !== 'string' || !/^[a-z][a-z0-9_]*$/.test(key)) return '';
    const nodes = document.querySelectorAll('script[data-aval-editor-copy="' + scope + '"]');
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      const text = node.textContent || '';
      let item = cache.get(node);
      if (!item || item.text !== text) {
        let values;
        try { values = JSON.parse(text); } catch (_) { values = null; }
        item = { text: text, values: values };
        cache.set(node, item);
      }
      const data = item.values;
      if (data && typeof data === 'object' && !Array.isArray(data) &&
          Object.prototype.hasOwnProperty.call(data, key)) {
        const value = typeof data[key] === 'string' ? data[key] : '';
        return html ? htmlText(value) : value;
      }
    }
    return '';
  };
}());
